// @ts-check
import React, { Component } from "react"
import { createPortal } from "react-dom"
import Input from "ui/legacy/Input"
import { BlockContextConsumer } from "../ContextProviders"

class BlockPropertiesPortal extends Component {
    /**
     * @param {BlockContext} context
     * @param {Broadcast_Property} property
     */
    updateProperty = (context, property, newName) => {
        context.broadcast.updatePublishedName(property.id, newName)
        context.actions.updateAttributes(
            context.block.id,
            "broadcast.property." + property.name,
            newName
        )
        context.actions.updateBroadcast(context.block.id, {
            id: property.id,
            published_name: newName,
        })
    }
    getList = context =>
        context.block.config.broadcast.filter(
            broadcast =>
                broadcast.channel === "property" && broadcast.ownerBlockId === context.block.id
        )
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block &&
                    ((!this.getList(context).length && <em>(none)</em>) || (
                        <div
                            className="RenderBlockTypeAttributes"
                            onClick={event => event.stopPropagation()}
                        >
                            Emitted Properties: {this.getList(context).length}
                            <br />
                            <ul>
                                {context.block.config.broadcast
                                    .filter(
                                        broadcast =>
                                            broadcast.channel === "property" &&
                                            broadcast.ownerBlockId === context.block.id
                                    )
                                    .map((/** @type {Broadcast_Property}*/ property) => (
                                        <li>
                                            <Input
                                                defaultValue={property.published_name}
                                                onChange={event =>
                                                    this.updateProperty(
                                                        context,
                                                        property,
                                                        event.target.value
                                                    )
                                                }
                                            />
                                            ({property.type})
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    ))
                }
            </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("properties"))
    }
}

BlockPropertiesPortal.propTypes = {}

export default BlockPropertiesPortal



// WEBPACK FOOTER //
// ./src/features/editor/properties/BlockPropertiesPortal.js